export default {
    type: 'person-specialisations',
    aliases: {
        camel: 'personSpecialisations',
        singular: 'Person Specialisations',
        plural: 'Person Specialisation',
        lowerSingular: 'person specialisation',
        lowerPlural: 'person specialisations',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
